<template>
    <div id="ProjectInfo">
        <!--这里v-bind动态赋予变量的值-->
        <AddProject v-bind:dialogAdd="dialogAdd" @update="getData"></AddProject>
        <EditProject :dialogEdit="dialogEdit" :form="form" @updateEdit="getData"></EditProject>
        <div class="data_head">
            <div class="search_input">
                <el-input v-model.trim="select_word" placeholder="输入项目名称（并按Enter键）" suffix-icon="iconfont icon-search" @keyup.enter.native="search()"></el-input>
            </div>
           <el-button type="primary" @click="handleAdd()" class="searchButton">添&nbsp;加</el-button>
        </div>
        <div class="table tableContent">
            <el-table :data="list" style="width: 100%" :header-cell-style="{background:'#335ABB',color:'#FFF'}" stripe>
                <el-table-column align="center" prop="name" label="项目名称"></el-table-column>
                <el-table-column align="center" prop="address" label="项目地址"></el-table-column>
                <el-table-column align="center" prop="description" label="项目信息"></el-table-column>
                <el-table-column align="center" prop="createUser" label="创建人"></el-table-column>
                <el-table-column align="center" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class="editButton">修&nbsp;改</el-button>
                        <el-button size="mini" @click="handleDelete(scope.row)" class="deleteButton">删&nbsp;除</el-button>
                        <!-- <el-button size="mini" @click="projectSwitch(scope.$index,scope.row)">项目切换</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="项目切换" :visible.sync="dialogSwitch" width="400px">
            <el-select v-model="value" value-key="pitNo" @change="selectJikeng">
                <el-option v-for="item in jikengList" :key="item.pitNo" :label="item.pitName" :value="item"></el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogSwitch = false">取 消</el-button>
                <el-button type="primary"  @click="save()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delDialogVisible" width="18%" :modal-append-to-body='false'>
            <span>删除不可恢复，是否确认删除</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="del">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

    import AddProject from './AddProject'
    import EditProject from './EditProject'

    export default {
        name: 'ProjectInfo',
        components: {
            AddProject,
            EditProject,
        },
        data() {
            return {
                select_word:'',
                data:[],
                list:[],
                dialogAdd:{
                    show:false
                },
                dialogEdit:{
                    show:false
                },
                delDialogVisible: false,
                form:{
                    name:'',
                    address:''
                },
                proInfo:{
                    projDesc:'',
                },
                dialogSwitch: false,
                value:'',
                jikengList:[],
            };
        },
        mounted: function () {
            this.getData();
        },
        methods:{
            getData(){
                this.$axios.post('api/monitor/project/projectInfo').then(res => {
                    if(res.data.status == 200){
                        this.data = res.data.datas.values;
                        this.getList();
                    }
                    return
                });
            },
            search(){
                this.getList();
            },
            getList(){
                this.list = this.data.filter((item) =>
                    item.name.includes(this.select_word)
                );
            },
            handleAdd(){
                this.dialogAdd.show = true;
            },
            handleEdit(index,row){
                this.dialogEdit.show = true;
                this.form={
                    name:row.name,
                    address:row.address,
                    description:row.description,
                    projectId:row.id,
                };
            },
            handleDelete(row) {
                this.delId = row.id;
                this.delDialogVisible = true;
            },
            del() {
                this.$axios.delete("/api/monitor/project/deleteProjectById", {params:{projectId: this.delId}}).then((res) => {
                    if(res.data.status == 200){
                        this.$message.success("删除成功");
                        this.delDialogVisible = false;
                        this.getData();
                    }
                    return
                });
            },
            projectSwitch(index,row){
                const req = {
                    id: row.id,
                }
                this.$axios.post('api/project/getfoundations',req).then(res => {
                    this.value = '';
                    this.dialogSwitch = true;
                    this.jikengList = res.data.data.data;
                })
            },
            selectJikeng(event){
                window.localStorage.setItem('pitNo2',event.pitNo);
            },
            save(){
                this.dialogSwitch = false;
                this.$router.push({
                    path: '/RealTimeMonitor',
                    name: 'RealTimeMonitor',
                    /* query: {
                        a:1
                    }   */
                })
            }
        }
    }
</script>


<style>

    #ProjectInfo .search_input .el-input__inner {
        background: #3457DE;
        border: 1px solid #3457DE;
        border-radius: 6px;
        width: 230px;
        font-size: 14px;
        color: #ffffff;
    }

    #ProjectInfo .el-table{
        color: #A7CCF6;
    }

    #ProjectInfo .el-table__row {
        background-color: #0B3A68 !important;
    }

    #ProjectInfo .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #ProjectInfo .el-table td{
        border: unset;
    }

    #ProjectInfo .el-table th.is-leaf{
        border-bottom: none;
    }

</style>

<style scoped>
    @import url('../../assets/css/style.css');

    .search_input{
        float: left;
        margin-left: 20px;
    }

    .editButton{
        background: #E68F02;
        border-color: #E68F02;
        color: #FFF;
    }

    .deleteButton{
        background: #FB4D4B;
        border-color: #FB4D4B;
        color: #FFF;
    }

</style>




// WEBPACK FOOTER //
// src/components/project/ProjectInfo.vue